import React from "react";
import { useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";
import { Card, ModernCardHeader } from "../../../components/cards";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { useCustomers } from "../../customers/hooks";

export const RecentCustomersWidget: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = useCustomers({ where: {} });

  const customers = [...(data?.customers?.results ?? [])]
    .sort((a, b) => b.id - a.id)
    .slice(0, 5);

  return (
    <Card>
      <ModernCardHeader
        title="Derniers clients"
        subtitle="Clients récemment ajoutés"
        action={
          <span
            className="text-xs text-indigo-600 cursor-pointer hover:underline"
            onClick={() => navigate("/customers")}
          >
            Voir tout
          </span>
        }
      />
      {loading ? (
        <Loading />
      ) : !customers.length ? (
        <EmptyList text="Aucun client" />
      ) : (
        <div className="space-y-1 mt-3">
          {customers.map((customer) => (
            <div
              key={`recent-customer-${customer.id}`}
              className="flex items-center justify-between gap-2 p-2 rounded-md hover:bg-gray-50 cursor-pointer border border-transparent hover:border-gray-200"
              onClick={() => navigate(`/customer/${customer.id}`)}
            >
              <div className="flex items-center gap-2 min-w-0">
                <div className="bg-indigo-50 text-indigo-600 p-1.5 rounded-md flex-shrink-0">
                  <Building2 className="w-4 h-4" />
                </div>
                <span className="text-sm text-gray-900 truncate">{customer.name}</span>
              </div>
              {customer.isComplete ? (
                <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-green-100 text-green-700 whitespace-nowrap">
                  Complète
                </span>
              ) : (
                <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 whitespace-nowrap">
                  Incomplète
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
